export const dataKeyMap = {
  guaranty: "guaranty", // 担保方式
  loan: "loan", // 贷款类型
  financialInstitution:'financialInstitution' //金融机构类型
}
